import React, { memo } from 'react';
import PropTypes from 'prop-types';
import AdContainerStyled from './styles/AdContainerStyled';

const AdContainer = ({ type, isHidden, isAdLinear, target = () => void 0 }) => (
  <AdContainerStyled
    id="mggp-ad-container"
    type={type}
    ref={target}
    isHidden={isHidden}
    isAdLinear={isAdLinear}
  />
);

AdContainer.propTypes = {
  target: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  type: PropTypes.string.isRequired,
  isHidden: PropTypes.bool.isRequired,
};

export default memo(AdContainer);
